<template>
  <div id="app" style="width: 100%; min-height: 100vh; ">
    <router-view />
  </div>
</template>

<script>
import router from './router';


export default {
  name: 'App',
  mounted() {
    // 禁用右键
    // document.addEventListener('contextmenu', this.disableRightClick)

    // 禁用快捷键
    document.addEventListener('keydown', this.disableKeys)
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    document.removeEventListener('contextmenu', this.disableRightClick)
    document.removeEventListener('keydown', this.disableKeys)
  },
  methods: {
    disableRightClick(e) {
      e.preventDefault()
    },
    disableKeys(e) {
      // 禁用 F12
      if (e.key === 'F12' || e.keyCode === 123) {
        e.preventDefault()
        router.push('/404') // 重定向到首页
        return false
      }
      // 禁用 Ctrl+Shift+I / Cmd+Opt+I
      if ((e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.metaKey && e.altKey && e.key === 'i')) {
        router.push('/404') // 重定向到首页
        e.preventDefault()
        return false
      }
      // 禁用 Ctrl+U / Cmd+Opt+U
      if ((e.ctrlKey && e.key === 'U') || (e.metaKey && e.altKey && e.key === 'u')) {
        router.push('/404') // 重定向到首页
        e.preventDefault()
        return false
      }
      // 禁用 Ctrl+Shift+C / Cmd+Opt+C
      if ((e.ctrlKey && e.shiftKey && e.key === 'C') || (e.metaKey && e.altKey && e.key === 'c')) {
        router.push('/404') // 重定向到首页
        e.preventDefault()
        return false
      }
      if ((e.ctrlKey && e.shiftKey && e.key === 'J') || (e.metaKey && e.altKey && e.key === 'j')){
        router.push('/404') // 重定向到首页
        e.preventDefault()
        return false
      }

    }
  }

}
</script>

<style>
/* 响应式基础设置 */
html {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  html {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  html {
    font-size: 12px;
  }
}

/* 全局重置样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

/* 字体定义 */
@font-face {
  font-family: 'MiSans';
  src: url('https://cdn.example.com/fonts/MiSans-Regular.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
</style>
